/**
 * Remove control characters (except tab/LF/CR) and HTML-dangerous angle brackets.
 * Allows Unicode letters/scripts (e.g. Japanese) and normal punctuation.
 */
const DISALLOWED_CHARS = /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F<>]/g;

export const PLAIN_TEXT_PATTERN =
  /^[^\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F<>]*$/;

export function sanitizePlainText(value: string) {
  return value.replace(DISALLOWED_CHARS, '');
}
